/**
 * @generated SignedSource<<89b027e30b3780f6b8cac124e701101c>>
 * @relayHash 0481678a27915107a3ab2adb52c2e123
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b974990a74bfc372f1062b5fb7128b96b7b2efa14d0d4623371ba38a9319d49a

import type { ConcreteRequest } from 'relay-runtime';
export type aiDescriptionButtonWrapperQuery$variables = {
  spaceId: string;
};
export type aiDescriptionButtonWrapperQuery$data = {
  readonly space: {
    readonly homepageId: string | null;
  } | null;
};
export type aiDescriptionButtonWrapperQuery = {
  response: aiDescriptionButtonWrapperQuery$data;
  variables: aiDescriptionButtonWrapperQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "spaceId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "spaceId"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "homepageId"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "aiDescriptionButtonWrapperQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "aiDescriptionButtonWrapperQuery",
    "selections": [
      {
        "args": (v1/*: any*/),
        "concreteType": "Space",
        "kind": "LinkedField",
        "name": "space",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b974990a74bfc372f1062b5fb7128b96b7b2efa14d0d4623371ba38a9319d49a",
    "metadata": {},
    "name": "aiDescriptionButtonWrapperQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "162796af29855f994bf05873d1c21a58";

export default node;
